"use strict"

import React, { useState, useEffect } from "react"
import { FormattedMessage } from "react-intl"
import { Button } from "react-bootstrap"

import { API_STATUS } from "../../../../shared_components/widgets/utils"
import { logToServer } from "../../../../ErrorBoundary"
import { addNewObject, getObjectsList } from "../../../../Loaders"

const styles = {
  icon: {
    height: "100px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "500",
    marginTop: "10px",
    color: "var(--lanzalake-black)",
  },
  message: {
    marginTop: "8px",
    maxHeight: "100px",
    overflowY: "auto",
  },
}

export default function SupervisorWidget(props) {
  // --- States ---
  const [state_start, setStateStart] = useState(null)
  const [state_stop, setStateStop] = useState(null)
  const [status, setStatus] = useState(null)
  const [message, setMessage] = useState(null)

  // --- On mount or update ---
  useEffect(() => {
    getStatus()
  })

  // TODO - New translations
  const stopSupervisorMsg = (err_msg) => "Error! Unable to stop Supervisor:\n" + err_msg
  const startSupervisorMsg = (err_msg) => "Error! Unable to start Supervisor:\n" + err_msg

  // --- Helpers ---
  const getStatus = () => {
    getObjectsList("/administration/api/supervisor/status/")
      .then((data) => {
        setStatus(data.status)
        setMessage(data.message)
      })
      .catch((error) => {
        logToServer(error)
        setStatus(null)
        setMessage("Unable to load service status.")
      })
  }

  // --- Events ---
  const onClick_start = (event) => {
    event.preventDefault()
    setStateStart(API_STATUS.LOADING)

    addNewObject("/administration/api/supervisor/action/", { action: "start" })
      .then((data) => {
        setStateStart(null)
        if (data.status === "success") {
          getStatus()
        } else {
          alert(startSupervisorMsg(data.message))
        }
      })
      .catch((error) => {
        console.error(error)
        logToServer(error)
        setStateStart(null)
        getStatus()
        alert(startSupervisorMsg(error))
      })
  }

  const onClick_stop = (event) => {
    event.preventDefault()

    if (
      !confirm(
        props.intl.formatMessage({
          id: `administration.system-management.are-you-sure-supervisor`,
        }),
      )
    ) {
      return false
    }

    setStateStop(API_STATUS.LOADING)

    addNewObject("/administration/api/supervisor/action/", { action: "stop" })
      .then((data) => {
        setStateStop(null)
        if (data.status === "success") {
          getStatus()
        } else {
          alert(stopSupervisorMsg(data.message))
        }
      })
      .catch((error) => {
        logToServer(error)
        setStateStop(null)
        getStatus()
        alert(stopSupervisorMsg(error))
      })
  }

  // --- Render ---
  return (
    <div className={"card"}>
      <div className={"card-body"}>
        <span>
          <span
            className={"fa fa-refresh"}
            style={{ float: "right", cursor: "pointer" }}
            onClick={getStatus}
          />
        </span>

        <div style={{ marginBottom: "20px" }} align={"center"}>
          {status === "running" ? (
            <img
              src={"/static/images/services/supervisor/supervisor_icon_ok.png"}
              alt={"OK Status Icon"}
              style={styles.icon}
            />
          ) : status === "not_running" ? (
            <img
              src={"/static/images/services/supervisor/supervisor_icon_error.png"}
              alt={"Error Status Icon"}
              style={styles.icon}
            />
          ) : (
            <img
              src={"/static/images/services/supervisor/supervisor_icon.png"}
              alt={"Supervisor Service Icon"}
              style={styles.icon}
            />
          )}
          <div style={styles.title}>Supervisor</div>

          {message !== null && (
            <div
              style={styles.message}
              className={
                status === "running" ? "text-success" : status === "not_running" ? "text-danger" : ""
              }
            >
              {message}
            </div>
          )}
        </div>

        <div className={"row"}>
          <div className={"col-6"} style={{ paddingRight: "7px" }}>
            <Button
              variant={"primary"}
              className={"btn btn-sm"}
              style={{ width: "100%" }}
              onClick={onClick_start}
              disabled={status === null || status === "running" || state_start === API_STATUS.LOADING}
            >
              {state_start === API_STATUS.LOADING ? (
                <>
                  <FormattedMessage id={"general.starting"} />
                  ...
                </>
              ) : (
                <FormattedMessage id={"general.start"} />
              )}
            </Button>
          </div>
          <div className={"col-6"} style={{ paddingLeft: "7px" }}>
            <Button
              variant={"outline-primary"}
              className={"btn btn-sm"}
              style={{ width: "100%" }}
              onClick={onClick_stop}
              disabled={status === null || status === "not_running" || state_stop === API_STATUS.LOADING}
            >
              {state_stop === API_STATUS.LOADING ? (
                <>
                  <FormattedMessage id={"general.stopping"} />
                  ...
                </>
              ) : (
                <FormattedMessage id={"general.stop"} />
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
